<template>

  <div class="row mt-3">
    <h3 class="col-12 col-md-9"> {{ controllerData.name }}</h3> 
    <div class= "col-3">
      <DxButton
        text="Apply changes"
        type="success"
        width="100%"
        @click="saveControllerChanges"
      />  
    </div>
    
    <!-- Common settings -->
    <DxForm :form-data="controllerData"  label-location="left" :min-col-width="350">
      <DxGroupItem :col-count="2" :min-col-width="350" caption="General settings">
        <DxSimpleItem data-field="name" 
        :editor-options="{ disabled: true }" />
        
        <DxSimpleItem 
          data-field="description" 
          editor-type="dxTextBox"
          :editor-options="{ maxLength: 300 }" 
        />
        <DxSimpleItem
          data-field="compType"
          editor-type="dxSelectBox"
          :editor-options="{ dataSource: controllerList, valueExpr:'id', displayExpr:'label', disabled:true  }"
          :label="{ text: 'type Controller'}"
        />
        <DxSimpleItem data-field="isEnabled" editor-type="dxCheckBox" />
        
      </DxGroupItem>
    </DxForm>


    <!-- specific settings -->
    <DxForm :form-data="advControllerData"  label-location="left" :min-col-width="350">
      <DxGroupItem :col-count="2" :min-col-width="350" caption="Frequency">
        <DxSimpleItem data-field="repeat" editor-type="dxCheckBox" />
        <DxSimpleItem data-field="typeTask" 
          editor-type="dxSelectBox"
          :editor-options="{ disabled:(advControllerData.repeat==0), dataSource: typeTaskList, valueExpr:'id', displayExpr:'value', onValueChanged:changedTypeTask }" />
        <DxSimpleItem
         v-if="(advControllerData.repeat==1 && advControllerData.typeTask==0)"
          data-field="periodTask" 
          editor-type="dxNumberBox"
          :editor-options="{ maxLength: 300, showSpinButtons:true }"
          :label="{text:'Period [ms]'}"/>
          
        <DxSimpleItem 
         v-if="(advControllerData.repeat==1 && advControllerData.typeTask==1)"
          data-field="cronTask" 
          editor-type="dxTextBox"
          :editor-options="{maxLength: 300}"/>
      </DxGroupItem>

      <DxGroupItem :col-count="2" caption="Controlled Component">
        <DxSimpleItem
          data-field="connection_id" 
          editor-type="dxLookup"
          :value="assetDS.find(as=>as.id==advControllerData.connection_id)"
          :editor-options="{searchEnabled:true, showClearButton:true, dataSource: assetDS, valueExpr:'id', displayExpr:'name',onValueChanged: selectedAssetChanged}"
          :label="{text:'Component'}"/>

        <DxSimpleItem
          data-field="signal_id" 
          editor-type="dxLookup"
          :value="signalDS.find(s=> s.signalId==advControllerData.signal_id)"
          :editor-options="{searchEnabled:true, showClearButton:true, dataSource: signalDS, valueExpr:'signalId', displayExpr:'name'}"
          :label="{text:'Signal'}"/>
      </DxGroupItem>
    

      <!-- Signals  configuration-->
      <!--<div class="row mt-3">
        <h3 class="col-12 col-md-10">Signals for {{ controllerData.controllerId }}</h3>
        <div class="col-2">
          <DxButton
            text="+"
            type="normal"
            width="100%"
            @click="showAddSignalForm"
          />
        </div>
      </div>-->
      <!--<div class="row mt-1">
        <DxDataGrid
          ref="SignalsDG"
          :data-source="signalDS"
          :show-borders="true"
          :column-hiding-enabled="true"
          height="400px">
          <DxScrolling mode="virtual"/>
          <DxSelection mode="single" />
          <DxColumn data-field="name" :min-width="100" :allow-editing="false" />
          <DxColumn data-field="label" :hiding-priority="0" />
        </DxDataGrid>
      </div>-->

      <!--<h3 class="col-12 col-md-6 mt-4" v-if="(controllerData.compType!='MaxAutarchy')"> {{ controllerData.compType }} parameters </h3> -->
      <DxGroupItem :col-count="2" :min-col-width="350" caption="Advanced settings"/>
    </DxForm> 
    
    <!-- controller special settings -->

    <DxToolbar>
      <DxItemTB
        :options="CalendarViewOptions"
        location="after"
        widget="dxButton"
      />
    </DxToolbar>

  <div id="chartContainer" class="mt-0">
    <DxChart
      :data-source="timelineDS">
        <DxSize :height="400"/>
        <DxMargin :right="10"/>
        <DxCommonSeriesSettings
          type="line"
          argument-field="timeStart"
          value-field="value"
          :lineWidth="60"/>
        <DxArgumentAxis
          :visual-range="[new Date('Thu Jan 01 1970 00:00:00 GMT+0100 (hora estándar de Europa central)').getTime(), 
                          new Date('Thu Jan 02 1970 00:00:00 GMT+0100 (hora estándar de Europa central)').getTime()]"
          :tick-interval="3600000"
          title="Hours"
          :label="{customizeText:customizeHours}"/>
        <DxSeries
          value-field="value"/>
        <DxValueAxis
          :tick-interval="20"
          :show-zero="true"
          :value-margins-enabled="false"
          :visual-range="[0, 100]"
          position="left"
          :label="{customizeText:customizeText}">
            <DxConstantLine
              :value="advControllerData.minSoE"
              :width="2"
              color="#fc3535"
              dash-style="dash"
              :label="{text:'min So E'}"/>
            <DxConstantLine
              :value="advControllerData.maxSoE"
              :width="2"
              color="#fc3535"
              dash-style="dash"
              :label="{text:'max So E'}"/>
            <DxGrid :visible="true"/>
        </DxValueAxis>
        <DxTitle text="SoE" alignment="left" :font="{size:13}"/>
        <DxLegend :visible="false"/>      
        <DxTooltip :enabled="true"/>
      </DxChart>
    </div>

    
    <!-- Soc Ref config -->
    <div id="accordion">
    <DxAccordion
      collapsible=true
      multiple=true
      animation-duration=300>
      <template #title="{ data }">
        <h5> {{ data.caption }} </h5>
      </template>
      <DxItem caption="Settings">
        <DxDataGrid
          ref="settingsDG"
          :data-source="opModesDS"
          :show-borders="true"
          :sync-lookup-filter-values="false"
          :column-auto-width="true">
          <DxSelection mode="single" />
          <DxEditing :allow-updating="true" :allow-deleting="true" mode="row" />
          <DxColumn data-field="name"  
            data-type="text" 
            :allow-editing="true" >
            <DxRequiredRule message="Field is required" />
            <DxCustomRule :validation-callback="NameValidation"
                message="Name is already registered" />
            <DxPatternRule pattern="^[A-Za-z0-9_]*$" message="The name can only contain letters and numbers" />
          </DxColumn>

          <DxColumn data-field="dateProfile" :allow-editing="true" cell-template="cellTemplate_dates">
            <DxLookup :data-source="advControllerData.dateProfiles" value-expr="id" display-expr="name"/>
            <DxRequiredRule message="Field is required" />
          </DxColumn>
          <template #cellTemplate_dates="{ data }">
            {{ get_date_name(data) }}
          </template>
          <DxColumn data-field="timeProfile" :allow-editing="true" cell-template="cellTemplate_times">
            <DxLookup :data-source="advControllerData.timeProfiles"  value-expr="id" display-expr="name"/>
            <DxRequiredRule message="Field is required" />
          </DxColumn>
          <template #cellTemplate_times="{ data }">
            {{ get_time_name(data) }}
          </template>
          <DxColumn data-field="value"  
            caption="SoE"
            data-type="number" 
            :allow-editing="true" 
            :editor-options="{min:0,max:100}">
            <DxRequiredRule message="Field is required" />
          </DxColumn>

          <DxColumn :width="80"
            data-field="color"
            caption=' '
            :allow-editing="true" 
            edit-cell-template="switchColor"
            cell-template="showColor"/>
            <template #switchColor="{ data }">
              <DxColorBox
                :value="data.value"
                @value-changed="setColorEditedValue($event, data)"/>
            </template>
            <template #showColor="{ data }" >
              <div  :style="{ backgroundColor: data.value, width:'15px',height:'15px'}"></div>
            </template>

          

          <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            mode="row" /> 
        </DxDataGrid>
      </DxItem>

      <DxItem caption="Edit Date Profiles">
        <DxDataGrid
          @editor-preparing="onDatePolEditorPrepare"
          :data-source=" dateProfilesDS">
          <DxColumn data-field="name" width="100" :column-min-width="100">
            <DxRequiredRule message="Field is required" />
            <DxCustomRule :validation-callback="NameDateValidation"
                message="Name is already registered" />
            <DxPatternRule pattern="^[A-Za-z0-9_]*$" message="The name can only contain letters and numbers" />
          </DxColumn>
          <DxColumn data-field="type" :set-cell-value="updateDatePolicyTypeVal" >
            <DxLookup :data-source="tariffDatePolicyTypes" value-expr="id" display-expr="name" />
            <DxRequiredRule message="Field is required" />
          </DxColumn>
          <DxColumn caption="Days of Week">
            <DxColumn data-field="daysOfWeek.mo" caption="Mo" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.tu" caption="Tu" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.we" caption="We" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.th" caption="Th" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.fr" caption="Fr" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.sa" caption="Sa" width="35" data-type="boolean" ></DxColumn>
            <DxColumn data-field="daysOfWeek.su" caption="Su" width="35" data-type="boolean" ></DxColumn>
          </DxColumn>
          <DxColumn data-field="daysCount" caption="Days in List" data-type="number" :allow-editing="false"></DxColumn>
          <DxColumn type="buttons" caption="Actions">
          <DxDGButton 
              :visible="isAddDateIntervalVisible"
              icon="insertcolumnright"
              hint="Add-Edit a date/range"
              :on-click="openDateIntervalPopUp"
          />
            <DxDGButton name="edit" />
            <DxDGButton name="delete" />  
          </DxColumn>
          <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            mode="row" /> 
          <DxSelection mode="single"/>
        </DxDataGrid>
      </DxItem>

      <DxItem caption="Edit Time Profiles">
        <DxDataGrid
          :data-source="timeProfilesDS">
          <DxColumn data-field="name" width="120">
            <DxRequiredRule message="Field is required" />
             <DxCustomRule :validation-callback="NameTimeValidation"
                message="Name is already registered" />
            <DxPatternRule pattern="^[A-Za-z0-9_]*$" message="The name can only contain letters and numbers" />
          </DxColumn>
          <DxColumn data-field="timeIni" caption="Time Lapses ini" 
            format= 'hh:mm a'  editor-type="dxDateBox" 
            :editor-options="{disabled: false, type:'time', format: 'hh:mm a' }">
            <DxRequiredRule message="Field is required" />
          </DxColumn>
          <DxColumn data-field="timeFin" caption="Time Lapses end" 
            format= 'hh:mm a'  editor-type="dxDateBox"
             :editor-options="{disabled: false, type:'time', format: 'hh:mm a' }">
            <DxRequiredRule message="Field is required" />
          </DxColumn>
          <DxEditing
            :allow-updating="true"
            :allow-adding="true"
            :allow-deleting="true"
            mode="row" />
          <DxSelection mode="single"/>
        </DxDataGrid>
      </DxItem>
      
      <DxItem caption="Edit other Settings">
        <DxForm :form-data="advControllerData"  label-location="left" :min-col-width="350">
        
          <DxGroupItem :col-count="2" :min-col-width="350" caption="Constraints"> 
            
            <DxSimpleItem 
              data-field="minSoE" 
              :label="{text:'Minimum SoE [%]'}"
              editor-type="dxNumberBox"
              :editor-options="{ maxLength: 300,min:0,max:100}" 
            />
            <DxSimpleItem 
              data-field="maxSoE" 
              :label="{text:'Maximum SoE [%]'}"
              editor-type="dxNumberBox"
              :editor-options="{ maxLength: 300,min:0,max:100}" 
            />
            <DxSimpleItem 
              data-field="maxChPower" 
              :label="{text:'Maximum charging power [W]'}"
              editor-type="dxTextBox"
              :editor-options="{ maxLength: 300 }" 
            />
            <DxSimpleItem 
              data-field="maxDsPower" 
              :label="{text:'Maximum discharging power [W]'}"
              editor-type="dxTextBox"
              :editor-options="{ maxLength: 300 }" 
            />
            
             <DxSimpleItem 
              data-field="settlingTime" 
              :label="{text:'Settling Time [Min]'}"
              editor-type="dxNumberBox"
              :editor-options="{ maxLength: 300}" 
            />
          </DxGroupItem>
        </DxForm>
      </DxItem>
    </DxAccordion>
  </div>

    
  </div>


  
<DxPopup
  :title="'Date list for: '+dateListPolicyObj.name"
  v-model:visible="isDateIntervalPopupOpen"
  :hide-on-outside-click="true"
  :height="600"
  :max-width="600"
   >
  <DxDataGrid 
    :data-source="dateListPolicyObj.dateList" 
    @saved="updateDatePolicyDList">
    <DxColumn data-field="description" data-type="text"><DxRequiredRule message="Description is required" /></DxColumn>
    <DxColumn data-field="dateStart" data-type="date"><DxRequiredRule message="Date start is required"/></DxColumn>
    <DxColumn data-field="dateEnd" data-type="date"><DxRequiredRule message="Date end is required"/></DxColumn>
    <DxColumn data-field="repYear" data-type="boolean" ></DxColumn>
    <DxEditing
      :allow-updating="true"
      :allow-adding="true"
      :allow-deleting="true"
      mode="row" /> 
    <DxSelection mode="single"/>
  </DxDataGrid>
</DxPopup>

<DxPopup
  title="Calendar View"
  v-model:visible="isCalendarPopupOpen"
  :hide-on-outside-click="true"
  :max-width="1000"
  :max-height="800">
  <DxScrollView 
    id="scrollview"
    :scroll-by-content="true"
    :scroll-by-thumb="true"
    show-scrollbar="On Hover"
    :bounce-enabled="false">
      <DxScheduler 
        ref="calendarResource"
        time-zone="Europe/Madrid"
        :data-source="calendarDS"
        :current-date="currentDateView"
        :views="['month','week']"
        current-view="month"
        :height="700"
        @option-changed ="calendarChanged"
        :editing="{allowAdding: false, allowDeleting: false, allowDragging: false, allowResizing: false, allowUpdating: false}"
        :resources="[{dataSource:calendarColorDS, fieldExpr:'text'}]">
          
      </DxScheduler>
  </DxScrollView>
</DxPopup>

</template>

<script>

import {
  DxForm,
  DxSimpleItem,
  //DxEmptyItem,
  DxGroupItem,
  DxItem,
} from 'devextreme-vue/form';
import RawDataService from '../services/RawDataServiceTemplate';
import notify from 'devextreme/ui/notify';
import DxButton from 'devextreme-vue/button';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import { ref,reactive } from '@vue/reactivity';

import {DxDataGrid,  
  DxSelection,
  DxEditing,
  DxColumn,
  DxButton as DxDGButton,
  DxLookup,
} from 'devextreme-vue/data-grid';


import {
  DxChart,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxTooltip, 
  DxConstantLine,
  DxLegend,
  DxTitle,
  DxValueAxis,
  DxSeries,
  DxMargin,
  DxSize
} from 'devextreme-vue/chart';

import {
  DxRequiredRule,
  DxPatternRule,
  DxCustomRule,
} from 'devextreme-vue/validator';
import { DxPopup } from 'devextreme-vue/popup';
import { daysOfSeparation } from '../utils/date-calcs.js';
import DxAccordion from 'devextreme-vue/accordion';
import DxToolbar, { DxItem as DxItemTB } from 'devextreme-vue/toolbar';
import {DxScheduler,
//DxResource,
} from 'devextreme-vue/scheduler';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import DxColorBox from 'devextreme-vue/color-box';

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxButton,

    DxItem,
    DxDataGrid,
    DxSelection,
    DxEditing,
    DxColumn,
    DxLookup,
    DxRequiredRule,
    DxCustomRule,
    DxDGButton,
    DxPopup,
    DxPatternRule,
    DxAccordion,
    DxToolbar,
    DxItemTB,
    DxChart,
    DxCommonSeriesSettings,
    DxArgumentAxis,
    DxTooltip, 
    DxConstantLine,
    DxLegend,
    DxTitle,
    DxValueAxis,
    DxSeries,
    DxMargin,
    DxSize,
    DxScheduler,
    DxScrollView,
    DxColorBox,
    //DxResource,
  },
  data(){
    return{      
      typeTaskList :[
        {id:0, value: 'Periodic task'},
        {id:1, value: 'Cron task'},
      ],

      CalendarViewOptions:{
        icon:'event', 
        hint:'Calendar View',
        onClick: ()=>{
          this.isCalendarPopupOpen = true;
          this.calendarDS.reload();
        }  
      },
    }
  },
  props:{
    controllerData:{
      id:null,
      name: null,
      uuid: null,
      description: null,
      isEnabled:null,
      compType:null
    },
    controllerList:{}
  },

  setup(props){

    const stErrorCb = err => { notify(err.message, "error", 3000); }

    const assetsDataService = new RawDataService('masters/assets');
    const signalDataService = new RawDataService('masters/signals');
    const controllerDataService = new RawDataService('controllers');
    

    const advControllerData = reactive({
      repeat:0,
      typeTask:0,
      periodTask:1000,
      cronTask: '0 * * * *',
      connection_id: null,
      signal_id:null,

      operatingModes:[],
      dateProfiles:[{name: 'Default'}],
      timeProfiles:[{name: 'Default'}],

      minSoE:null,
      maxSoE: null,
      maxChPower:  null,
      maxDsPower: null,
      settlingTime:0,
    });


    // SPECIFIC SETTINGS

    
    const isDateIntervalPopupOpen = ref(false);
    const isCalendarPopupOpen = ref(false);
    const settingsDG = ref()
    const calendarResource= ref(null);
    
    //////// Dates table  ////////////////////////////////////////////////////////////////////////////

    let tariffDatePolicyTypes = [
    {id:'DaysOfWeek', name:'Days of Week'}, 
    {id:'ListOfDates', name:'List of Days'}];

    const dateProfilesStore = new CustomStore({
      key: 'id',
    
      load: async() => {
        try{
          const newDs=[];
          for(const date of advControllerData.dateProfiles){
            newDs.push({
              id:date.id,
              name:date.name,
              type:date.type,
              daysOfWeek:date?.daysOfWeek || {mo:false,tu:false,we:false,th:false,fr:false,sa:false,su:false},
              dateList:date?.dateList || [],
              daysCount:date.daysCount 
            });            
          }
          return newDs;
        }catch(err) { notify('error loading date table: '+err.message, 'error', 4000); } 
      },  
      update: async(e,data) =>{
        try{
          const item_old = advControllerData.dateProfiles.find(i=> i.id==e);
          if (data?.daysOfWeek){
            const aux=data.daysOfWeek;
            data.daysOfWeek=item_old.daysOfWeek;
            Object.assign(data.daysOfWeek,aux);
          }
          Object.assign(item_old,data)

        }catch(error){ stErrorCb(error); }
      },
      insert: async(data) =>{
        try{
          data.id=data.name+'_'+ Math.floor(Math.random() * 1000000000);
          if(!data?.daysOfWeek) data.daysOfWeek = {mo:false,tu:false,we:false,th:false,fr:false,sa:false,su:false};
          if(!data?.dateList) data.dateList = [];
          advControllerData.dateProfiles.push(data)
        }
        catch(error){ stErrorCb(error); }
      }, 
      remove: async(e) => {
        try{
           advControllerData.dateProfiles = advControllerData.dateProfiles.filter(i=>i.id!=e)
        }catch(error){ stErrorCb(error); }
      },
      byKey: () => {
      }

    });
    const dateProfilesDS = new DataSource({
      store: dateProfilesStore,
      paginate: false
    }); 

    const NameDateValidation = (params)=>{
      const param=dateProfilesDS._items.find(e=>  e.name==params.value &  e.id!=params.data.id);
      return !param
    }
   

    ///// TIME PROFILEs ////////////////////////////////////////////////////////////////////////

    const timeProfilesStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{
            const newDs=[];
            for(const time of advControllerData.timeProfiles){
              newDs.push({
                id:time.id,
                name:time.name,
                timeIni: new Date(time.timeIni), //new Date('Wed Jan 01 2023 '+datos.timeIni+':40 GMT+0100'),
                timeFin: new Date(time.timeFin), //new Date('Wed Jan 01 2023 '+datos.timeFin+':40 GMT+0100'), 
              });            
            }
            return newDs;
        }catch(error){ stErrorCb(error); }
      },
      update: async(e,data) => {
        try{
          const item_old = advControllerData.timeProfiles.find(i=>i.id==e)
          if (data?.timeFin) data.timeFin = data.timeFin.toISOString()
          if (data?.timeIni) data.timeIni = data.timeIni.toISOString()
          Object.assign(item_old,data)
          timelineDS.reload();
        }catch(error){ stErrorCb(error); }
      },
      insert: async(data) =>{
        try{
          if (data?.timeFin) data.timeFin = data.timeFin.toISOString()
          if (data?.timeIni) data.timeIni = data.timeIni.toISOString()
          data.id=data.name+'_'+ Math.floor(Math.random() * 1000000000);
          advControllerData.timeProfiles.push(data)
        }
        catch(error){ stErrorCb(error); }
      },
      remove: async(e) => {
        advControllerData.timeProfiles = advControllerData.timeProfiles.filter(i=>i.id!=e)
      },
      byKey: () => {
      }
    });

    const timeProfilesDS = new DataSource({
      store: timeProfilesStore,
      paginate: false
    }); 
    
    const NameTimeValidation = (params)=>{
      const param=timeProfilesDS._items.find(e=> e.name==params.value &  e.id!=params.data.id);
      return !param
    }

  // Setting table //////////////////////////////////////////////
    
    const opModesStore = new CustomStore({
      key: 'id',
      load: async() => {
        try{  
          const newDs=[];
          for(const time of advControllerData.operatingModes){
            newDs.push({
              id:time.name,
              name:time.name,
              dateProfile: time.dateProfile, 
              timeProfile: time.timeProfile,
              value: time.value,
              color: time.color
            });            
          }
          return newDs;
      }catch(err) { notify('error loading operating modes: '+err.message, 'error', 4000); }
      },  
      update: async(e,data) =>{
         try{
          const item_old = advControllerData.operatingModes.find(i=> i.name==e);
          Object.assign(item_old,data)
          timelineDS.reload();
          await calendarColorDS.reload()
          calendarDS.reload();
          settingsDG.value.instance.refresh()
          
        }catch(error){ stErrorCb(error); }
      },
      insert: async(data) =>{
        try{
          data.id=data.name;
          advControllerData.operatingModes.push(data)
          timelineDS.reload();
          calendarDS.reload();
          settingsDG.value.instance.refresh()
        }
        catch(error){ stErrorCb(error); }
      },
      remove: async(e) => {
        try{
           advControllerData.operatingModes = advControllerData.operatingModes.filter(i=>i.id!=e)
           timelineDS.reload();
           calendarDS.reload();
        }catch(error){ stErrorCb(error); }
      },

    });
    const opModesDS = new DataSource({
      store: opModesStore,
      paginate: false
    }); 


    const NameValidation = (params)=>{
      const param=opModesDS._items.find(e=>  e.name==params.value &  e.id!=params.data.id);
      return !param
    }


    // Graph View /////////////////////////////////////////////
    const timelineStore = new CustomStore({
      load: () => {
        try{
          let newDs =[];
          const opModesStore_current = advControllerData.operatingModes;
          let id_count=1;
          for(const SR of opModesStore_current){
            const timeProfile= advControllerData.timeProfiles?.find(p => p.id == SR.timeProfile ) || null
            if (timeProfile){
              newDs.push({
                id: id_count,
                name:SR.name,
                value:SR.value,
                timeStart: new Date(timeProfile.timeIni).getTime(),//new Date(timeProfile.timeIni).getTime(),
              })
              id_count=id_count+1;
            }
          }

          for(const SR of opModesStore_current){
            const timeProfile= advControllerData.timeProfiles?.find(p => p.id == SR.timeProfile ) || null
            const timeIni = new Date(timeProfile.timeIni).getTime()
            const timeFin = new Date(timeProfile.timeFin).getTime()
            if (timeProfile){
              const midPoint = newDs.find(p=>p.timeStart>timeIni && p.timeStart<timeFin)
              if (!midPoint){
                newDs.push({
                  id: id_count+1,
                  name:SR.name, 
                  value:SR.value,
                  timeStart: timeFin-1
                })
              }else{
                newDs.push({
                  id: id_count+1,
                  name:SR.name,
                  value:SR.value,
                  timeStart: midPoint.timeStart-1
                })
              }
              id_count=id_count+1;
            } 
          }
          return newDs;
        }catch(err) { notify('error building graph: '+err.message, 'error', 4000); }
        
      }, 

    });

    const timelineDS =  new DataSource({
      store: timelineStore,
      paginate: false
    }); 

    // Calendar View ///////////////////////////////////////////////
    var currentDateView=new Date();
    const calendarStore = new CustomStore({
      key:"id",
      load: () => {
        let month = currentDateView.getMonth();
        let year = currentDateView.getFullYear();
        let monthdays= 32
        
        let days = [];
        for(var SR of advControllerData.operatingModes){
          let dateProfile = advControllerData.dateProfiles.find(p => p.id == SR.dateProfile) ;
          let timeProfile = advControllerData.timeProfiles.find(p => p.id == SR.timeProfile) ;
          if(dateProfile && timeProfile){
            let hourI = new Date(timeProfile.timeIni).getHours();
            let hourF = new Date(timeProfile.timeFin).getHours();
            let minutesI = new Date(timeProfile.timeIni).getMinutes();
            let minutesF = new Date(timeProfile.timeFin).getMinutes();

            for (var i = 1; i<monthdays; i++){

              if (dateProfile.type=="DaysOfWeek"){
                let day = new Date(year,month,i).getDay();

                switch (day){
                  case 0:
                    if(dateProfile.daysOfWeek.su) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 1:
                    if(dateProfile.daysOfWeek.mo) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 2:
                    if(dateProfile.daysOfWeek.tu) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 3:
                    if(dateProfile.daysOfWeek.we) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 4:
                    if(dateProfile.daysOfWeek.th) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 5:
                    if(dateProfile.daysOfWeek.fr) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  case 6:
                    if(dateProfile.daysOfWeek.sa) {
                      days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                    }
                    break;
                  
                }
                
              //dateProfile.daysOfWeek.mu 

              }else if(dateProfile.type=="ListOfDates"){
                let day = new Date(year,month,i);
                const dates = dateProfile.dateList;
                //let arraydates = []
                for(var date of dates){
                  let dateStart = new Date(date.dateStart);
                  let dateEnd = new Date(new Date(date.dateEnd).getTime()+1000*60*60*24);
                  if(day>=dateStart && day<(dateEnd)){
                    days.push({
                        text: SR.name,
                        startDate: new Date(year,month,i,hourI,minutesI),
                        endDate:new Date(year,month,i,hourF,minutesF),
                        color: SR.color
                      })
                      break;
                  }
                }
              }
            }
            
          }else{
            notify('error building calendar', 'error', 4000);

          }
        }
        return days;
      }, 

    });

    const calendarDS =  new DataSource({
      store: calendarStore,
      paginate: false
    }); 

     const calendarColorStore = new CustomStore({
      key:"id",
      load: () => {
        const groups = advControllerData.operatingModes;
        let newDs=[];
        for(const group of groups){
          newDs.push({
            id: group.name,
            color: group.color,
            text: group.name
          })
        }
        return newDs;
      }
     })
    const calendarColorDS =  new DataSource({
      store: calendarColorStore,
      paginate: false
    }); 


    /*const eventsColors = ()=>{
      const groups = opModesDS._items;
      let newDs=[];
      for(const group of groups){
        newDs.push({
          id: group.name,
          color: group.color,
          text: group.name
        })
      }
      //console.log(newDs)
      return newDs;
    }*/
    
    const setColorEditedValue=(valueChangedEventArg, cellInfo) =>{
      cellInfo.setValue(valueChangedEventArg.value);
    }
    

    
    ////////////////////////////////////////////////////////////////
  
    const onDatePolEditorPrepare = (e) => {  
      let rowData = e.row.data;
      const weekdayFields = ['daysOfWeek.su', 'daysOfWeek.mo', 'daysOfWeek.tu', 'daysOfWeek.we', 'daysOfWeek.th', 'daysOfWeek.fr', 'daysOfWeek.sa']
      
      if (rowData.type =='DaysOfWeek'){
        e.editorOptions.disabled = false;
        e.editorOptions.visible = true;
      } 
      if (rowData.type =='ListOfDates' &&  weekdayFields.includes(e.dataField)){
        e.editorOptions.disabled = true;
        e.editorOptions.visible = false;
      } 
      
    }
    const updateDatePolicyTypeVal= (newData, value) =>{
      newData.type = value;
      newData.daysOfWeek = {mo:false, tu:false, we:false, th:false, fr:false, sa:false, su:false};
    }

    const dateListPolicyObj = reactive({
        id: null,
        name: null,
        dateList: [],
        daysCount: 0
    });
    const openDateIntervalPopUp = (e) => { 
      if (e.row && e.row.rowType=="data"){
        dateListPolicyObj.id = e.row.data.id;
        dateListPolicyObj.name = e.row.data.name;
        dateListPolicyObj.dateList = e.row.data.dateList || [];
        dateListPolicyObj.daysCount = e.row.data.daysCount||0;
        isDateIntervalPopupOpen.value = true;       
      }else{
        console.log('Error: no dates can be edited for this element');
      }
    }

    const isAddDateIntervalVisible = (e) => {//enabled after saved, only for type 'ListOfDates'
      return (e.row.rowType=="data" && e.row.data.type=="ListOfDates" && !e.row.isEditing)
    }

    const updateDatePolicyDList = async () => {//updates datePolicy store with changes from list of days
      let daysCount = 0;
      for (const dateObj of dateListPolicyObj.dateList){
        daysCount += dateObj.dateEnd? daysOfSeparation(dateObj.dateStart, dateObj.dateEnd)+1 : 1;
      }
      try{
        let item_old = advControllerData.dateProfiles.find(p => p.id==dateListPolicyObj.id);
        let data = { daysCount: daysCount, dateList: dateListPolicyObj.dateList };
        Object.assign(item_old, data);
        dateProfilesDS.reload();
      }catch(error){ stErrorCb(error); }
    }

    const customizeText = ( value ) => {
      return value.valueText+ ' %';
    };

    const customizeHours = ( value ) => {
      var date = new Date(value.value)
      return formatDate(date);
    };

    function formatDate(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    }

    const calendarChanged = (e)=>{
      if (e.name === "currentDate") {
          currentDateView = e.value;
      }
    }

    /// SAVE 

    const saveControllerChanges = async () => {
      // Comun settings
      try{
        controllerDataService.update(props.controllerData.name, props.controllerData).then(res =>{        
          if(res.isOk){
            notify(res.message||"controller updated", "success", 3500)
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
        })
        
        // Advanced Settings
        const controllerParams = {
          controllerId: props.controllerId,
          paramName: 'static',
          paramSchema: JSON.stringify({type:'object', //TODO: save schemas in other file
                          properties:{
                          }}),
          value: JSON.stringify(advControllerData),
          description: null,
        }; 
        
        const paramsControllerService=  new RawDataService('controllers/'+ props.controllerData.id +'/params');
        const PowerParam  = await paramsControllerService.getAll();
        const Staticf=PowerParam.find?.(param=>{
          return param.paramName == 'static';
        });

        paramsControllerService.update(Staticf.param_id, controllerParams).then(res =>{        
          if(res.isOk){
            notify(res.message||"controller updated", "success", 3500)
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
        });
      }catch(error){
        stErrorCb(error);
      }
    }
    

    // signal list
   
    const signalDS=ref([])
    const selectedAssetChanged = async()=>{

      signalDS.value = []
       const component = assetDS.value.find(el => el.id == advControllerData.connection_id);
      if(component){
        signalDS.value = await signalDataService.getAll();
        signalDS.value=signalDS.value.filter(s=>s.assetName==component.name)

         if (!signalDS.value.find(s=>s.signalId == advControllerData.signal_id)){
          advControllerData.signal_id=null
        }
      }
    }



    const get_date_name = (id)=>{
      return advControllerData.dateProfiles.find(sig => sig.id==id.value)?.name || ''
    }
    const get_time_name = (id)=>{
      return advControllerData.timeProfiles.find(sig => sig.id==id.value)?.name || ''
    }
    /// LOAD ///////////////

    const assetDS = ref([])
    const loadById = async () => {
      // get advanced settings
      const paramsControllerService =  new RawDataService('controllers/'+ props.controllerData.id +'/params');
      const staticParam = await paramsControllerService.getAll().then(res => {
        const param = res.find(param => {
          return param.paramName == 'static';
        });
        return (param)
      }).catch(stErrorCb);

      if(staticParam)
        Object.assign(advControllerData,JSON.parse(staticParam.value));  
     
      // Get asset list
      await assetsDataService.getAll().then(res =>{
        res.forEach((com)=>{
          assetDS.value.push({
            type:'asset',
            name: com.name,
            id:com.id
          })
        })
      });

      const component = assetDS.value.find(el => el.id == advControllerData.connection_id);
      if (component){
        signalDS.value = await signalDataService.getAll();
        signalDS.value=signalDS.value.filter(s=>s.assetName==component.name)
      } 

      timeProfilesDS.reload();
      dateProfilesDS.reload();
      opModesDS.reload();
      calendarDS.reload();
      timelineDS.reload();
    }

    loadById();


    return{
      advControllerData,
      saveControllerChanges,
      loadById,
      assetDS,
      signalDS,
      selectedAssetChanged,
      settingsDG,

      calendarChanged,
      currentDateView,
      calendarResource,
      
      opModesDS,
      NameValidation,
      NameDateValidation,
      NameTimeValidation,
      tariffDatePolicyTypes,
      onDatePolEditorPrepare,
      timeProfilesDS,
      dateProfilesDS,
      timeProfilesStore,
      dateProfilesStore,
      updateDatePolicyTypeVal,

      timelineDS,
      calendarDS,
      calendarStore,
      setColorEditedValue,
      //eventsColors,
      calendarColorDS,

      isDateIntervalPopupOpen,
      isCalendarPopupOpen,
      dateListPolicyObj,
      openDateIntervalPopUp,
      isAddDateIntervalVisible, 
      updateDatePolicyDList,

      customizeText,
      customizeHours,
      get_date_name,
      get_time_name,

    }
  },
  methods:{
    
  }

}


</script>

<style>


#accordion h5 {
  font-size: 1rem;
}

#accordion h5,
#accordion p {
  margin: 0;
  padding: 0.2rem ;
}
#chartContainer {
  height:400px;
}
.box{
  border-color: gray;
  border-width: 1px;
  border-style: dotted;
}

</style>
